﻿import { SetVisningAction, SET_VISNING, ResultatValgVisning } from './Types';

export function setVisning(stegVisning: Partial<ResultatValgVisning>): SetVisningAction {
    return {
        type: SET_VISNING,
        payload: stegVisning,
    };
}
